import { useNavigate } from "react-router-dom";
import {
  tokenSolver,
  appVersion,
  privSponsorKey,
  privTokenKey,
  privIsValidToken,
  getFromStorage,
  showOnlyIfNotProd,
} from "../utils";
import { not_found, stars_error } from "./../pngs";
import { EmptyBlock, CoalitionButton } from "../components";
import "./../App.scss";

const msg = {
  textAlign: "center",
  color: "#777171",
};

export const StarsPromoError = () => {
  return (
    <div className="reduced-error-page">
      <EmptyBlock
        description={
          "Tenemos problemas para mostrarte la lista de personas que ganaron. Por favor, inténtalo más tarde"
        }
        emptyState={stars_error}
        isError={true}
      />
    </div>
  );
};

export const Page401 = ({ ctx }) => {
  const header = getFromStorage(privSponsorKey, false);
  const token = getFromStorage(privTokenKey, false);
  const validToken = getFromStorage(privIsValidToken, false);
  return (
    <div className="reduced-error-page">
      <ErrorPage
        title={"Error 401"}
        description={"Necesitas Iniciar sesión para acceder a este contenido"}
      />
      {showOnlyIfNotProd(
        <>
          {!token ? <div style={msg}>{"Token not provided"}</div> : null}
          {!validToken ? (
            <>
              <div style={msg}>{"Token provided not valid"}</div>
              <div style={msg}>{"Tried to reach:"}</div>
              <div
                style={msg}
              >{`https://${window.location.host}?${header}=${token}`}</div>
            </>
          ) : null}
        </>
      )}
      <div style={msg}>{`${appVersion()} - (${ctx})`}</div>
    </div>
  );
};

export const Page404 = () => {
  const navigate = useNavigate();
  return (
    <div className="reduced-error-page">
      <ErrorPage
        title={"Error 404"}
        description={
          "No encontramos la página que buscas, por favor regresa a nuestra página principal"
        }
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      />
    </div>
  );
};

const ErrorPage = ({ title, description, buttonClicked }) => {
  return (
    <div>
      <EmptyBlock
        title={title}
        description={description}
        emptyState={not_found}
        isError={true}
      >
        {buttonClicked ? (
          <CoalitionButton
            label="Volver al Inicio"
            klass="coalition-button-go-dashboard"
            onClickEvent={buttonClicked}
          />
        ) : null}
      </EmptyBlock>
    </div>
  );
};
